import type Point from '@arcgis/core/geometry/Point';
import type { PointerMoveEvent } from '@arcgis/core/views/input/types';
import type { GraphicHit, ViewHitTestResult } from '@arcgis/core/views/types';
import type { ArcgisMap } from '@arcgis/map-components/components/arcgis-map';

import type { Map2 } from './map-2';

import { CalculatePopoverPosition } from './calculate-popover-position';

export function ClearHover(this: Map2): void {
  if (!this.hoveredListingId) {
    return;
  }

  this.hoveredListingId = undefined;
  this.stateService.hoveredListing.set(undefined);
}

export function HandlePointerMove(this: Map2, event: CustomEvent<PointerMoveEvent>): void {
  void (event.target as ArcgisMap).hitTest(event.detail).then((response) => {
    applyHitTest.call(this, response);
  });
}

function applyHitTest(this: Map2, response: ViewHitTestResult): void {
  // Only individual (non-clustered) point graphics represent a single listing that can be hovered.
  const _hit = response.results.find(
    (r): r is GraphicHit => r.type === 'graphic' && !r.graphic.isAggregate,
  );
  const _id = (_hit?.graphic.attributes as undefined | { id?: string })?.id;

  if (!_hit || !_id) {
    ClearHover.call(this);

    return;
  }

  if (_id === this.hoveredListingId) {
    return;
  }

  const _listing = this.mappedListings().get(_id);
  if (!_listing) {
    return;
  }

  const _mapEl = this.mapElement()?.nativeElement as ArcgisMap | undefined;
  if (!_mapEl) {
    return;
  }

  const _position = CalculatePopoverPosition(_mapEl, _hit.graphic.geometry as Point);
  if (!_position) {
    return;
  }

  this.hoveredListingId = _id;
  this.listingPopoverLeft.set(_position.left);
  this.listingPopoverTop.set(_position.top);
  this.stateService.hoveredListing.set(_listing);
}
